export default () => {
  const trackingColor = (code: string) => {
    switch (code) {
      case "BOOKED":
      case "TRANSIT":
      case "on_track":
        return ComponentColor.Blue;
      case "DELIVERED":
      case "completed":
        return ComponentColor.Green;
      case "DEVIATION":
      case "major_deviation":
        return ComponentColor.Yellow;
      case "EXCEPTION":
      case "cancelled":
        return ComponentColor.Red;
      case "RETURN":
      case "INFO":
      case "return":
        return ComponentColor.Grey;
      case "paused":
        return ComponentColor.Orange;
      default:
        return ComponentColor.Blue;
    }
  };

  const trackingIcon = (code: string) => {
    switch (code) {
      case "BOOKED":
      case "TRANSIT":
      case "on_track":
        return "check_circle";
      case "DELIVERED":
      case "completed":
        return "check_circle";
      case "DEVIATION":
      case "major_deviation":
        return "warning_circle";
      case "INFO":
        return "info";
      case "EXCEPTION":
      case "cancelled":
        return "flag_banner";
      case "RETURN":
      case "return":
        return "arrow_u_down_left";
      case "paused":
        return "pause_circle";
      default:
        return "check_circle";
    }
  };

  return { trackingColor, trackingIcon };
};
